
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytic/view",
      function () {
        return require("private-next-pages/analytic/view.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analytic/view"])
      });
    }
  